// Package Imports
import { Button, Result } from 'antd'
import { useNavigate } from '@tanstack/react-router'

// Core Imports
import { ROUTES } from '@/core/constants/routes'

/**
 * Detay rotasının 404 (GENERATION_NOT_FOUND) fallback'i. Silinmiş ya da hiç var
 * olmamış bir üretim grubuna gidildiğinde, jenerik "Bu sayfa yüklenemedi" hata
 * ekranı yerine zarif bir "bulunamadı" durumu + listeye dönüş gösterir.
 */
const BatchNotFound = () => {
  const navigate = useNavigate()

  return (
    <Result
      status="404"
      title="Üretim grubu bulunamadı"
      subTitle="Bu üretim grubu silinmiş ya da hiç var olmamış olabilir."
      extra={
        <Button
          type="primary"
          onClick={() => navigate({ to: ROUTES.questionGeneration })}
        >
          Listeye Dön
        </Button>
      }
    />
  )
}

export default BatchNotFound
